// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Bq1","index":"styles_index__2P6rV"};